import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import Button from '@/components/ui/Button';

export default function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-slate-50">
      <div className="text-center space-y-6">
        <div>
          <h1 className="text-9xl font-bold text-slate-200">404</h1>
          <h2 className="text-3xl font-bold text-slate-900 mt-4">Page non trouvée</h2>
          <p className="text-slate-600 mt-2">
            Désolé, la page que vous recherchez n'existe pas ou a été supprimée.
          </p>
        </div>

        <Link to="/">
          <Button variant="primary" size="lg">
            <Home className="w-4 h-4" />
            Retour à l'accueil
          </Button>
        </Link>
      </div>
    </div>
  );
}
